(function () {
    'use strict';

    angular.module("imApp").factory("ohDirectDeliveryService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1694,
                    parameters: parms || {}
                });
            },
            listDirectDeliveries: function (parms) {
                return $ihttp.post({
                    method: 1695,
                    parameters: parms || {}
                });
            },
            deliverObj: function (mergeObj) {
                return $ihttp.post({
                    method: 1696,
                    parameters: mergeObj
                });
            }
        };

        return service;
    }]);
})();
